<div class="modal-box client-reporting-update-modal" cdkDrag>
  <form class="client-reporting-update-modal__form modal-form" [formGroup]="editForm" (ngSubmit)="onSubmit()">
    <div class="modal-header client-reporting-update-modal__header" cdkDragHandle>
      <div class="client-reporting-update-modal__headline modal-headline">
        <span class="client-reporting-update-modal__eyebrow modal-eyebrow">{{ 'REPORTING' | translate }}</span>
        <h4 class="modal-title client-reporting-update-modal__title modal-heading">{{ (!(ReportingConfig?.id) || ReportingConfig.id === '') ? ('ADD_WEEKLY_EMAIL_REPORT' | translate) : ('EDIT_WEEKLY_EMAIL_REPORT' | translate) }}</h4>
      </div>
      <button type="button" class="client-reporting-update-modal__close modal-close" [attr.aria-label]="('CLOSE' | translate)" (click)="activeModal.dismiss('Cross click')">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>

    <div class="modal-body client-reporting-update-modal__body">
      <div class="client-reporting-update-modal__layout">
        <section class="client-reporting-update-modal__panel client-reporting-update-modal__panel--main modal-panel">
          <div class="client-reporting-update-modal__section">
            <div class="row g-3">
              <div class="col-12 col-lg-6 form-group">
                <label class="client-reporting-update-modal__label" for="reportingClient">{{ 'CLIENT' | translate }}</label>
                <input
                  id="reportingClient"
                  type="text"
                  class="form-control client-reporting-update-modal__control"
                  [value]="(
                    instance.isAltLayout
                      ? (ReportingConfig.client?.lastName || '')
                      : (
                          (
                            instance.isLastNameFirst
                              ? ((ReportingConfig.client?.lastName || '') + ' ' + (ReportingConfig.client?.firstName || ''))
                              : ((ReportingConfig.client?.firstName || '') + ' ' + (ReportingConfig.client?.lastName || ''))
                          ).trim()
                        )
                  )"
                  readonly>
              </div>

              <div class="col-12 col-lg-6 form-group">
                <label class="client-reporting-update-modal__label" for="toEmail">{{ 'TO_EMAIL' | translate }}</label>
                <input id="toEmail" type="text" class="form-control client-reporting-update-modal__control" formControlName="toEmail"
                  [ngClass]="{ 'is-invalid': submitted && f.toEmail.errors }">
                <div *ngIf="submitted && f.toEmail.errors" class="invalid-feedback">
                  <div *ngIf="f.toEmail.errors.required">{{ 'EMAIL_REQUIRED' | translate }}</div>
                  <div *ngIf="f.toEmail.errors.email">{{ 'EMAIL_INVALID' | translate }}</div>
                </div>
              </div>

              <div class="col-12 form-group">
                <label class="client-reporting-update-modal__label">{{ 'CC_EMAILS' | translate }}</label>
                <div class="client-reporting-update-modal__cc-block" formArrayName="rmReportingConfigCcemails">
                  <div class="client-reporting-update-modal__cc-list">
                    <div *ngFor="let cc of rmReportingConfigCcemails.controls; let i = index" class="client-reporting-update-modal__cc-item" [formGroupName]="i">
                      <input type="text" class="form-control client-reporting-update-modal__control" formControlName="ccEmail"
                        [ngClass]="{ 'is-invalid': submitted && cc.get('ccEmail')?.errors }">
                      <button type="button" class="client-reporting-update-modal__icon-button" (click)="removeReportingCC(i)">
                        <i-feather name="trash-2"></i-feather>
                      </button>
                      <div *ngIf="submitted && cc.get('ccEmail')?.errors" class="invalid-feedback client-reporting-update-modal__cc-feedback">
                        <div *ngIf="cc.get('ccEmail')?.errors?.required">{{ 'EMAIL_REQUIRED' | translate }}</div>
                        <div *ngIf="cc.get('ccEmail')?.errors?.email">{{ 'EMAIL_INVALID' | translate }}</div>
                      </div>
                    </div>
                  </div>

                  <button type="button" class="orange-button client-reporting-update-modal__inline-button" (click)="addNewCC()">
                    <i-feather name="plus"></i-feather>
                    <span>{{ 'CC_EMAILS' | translate }}</span>
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div class="client-reporting-update-modal__section">
            <div class="row g-3">
              <div class="col-12 col-lg-7 form-group">
                <label class="client-reporting-update-modal__label">{{ 'REPORT_TYPE' | translate }}</label>
                <div class="client-reporting-update-modal__radio-group" [ngClass]="{ 'is-invalid': submitted && f.reportType.errors }">
                  <label class="client-reporting-update-modal__radio-option">
                    <input type="radio" value="Simple" formControlName="reportType" (click)="clearEditFormCampaigns()"
                      [attr.disabled]="!(ReportingConfig?.id) || ReportingConfig.id === '' ? null : true"
                      [ngClass]="{ 'is-invalid': submitted && f.reportType.errors }">
                    <span>{{ 'SIMPLE' | translate }}</span>
                  </label>
                  <label class="client-reporting-update-modal__radio-option">
                    <input type="radio" value="Advanced" formControlName="reportType" (click)="clearEditFormCampaigns()"
                      [attr.disabled]="!(ReportingConfig?.id) || ReportingConfig.id === '' ? null : true"
                      [ngClass]="{ 'is-invalid': submitted && f.reportType.errors }">
                    <span>{{ 'ADVANCED' | translate }}</span>
                  </label>
                </div>
                <div *ngIf="submitted && f.reportType?.errors" class="client-reporting-update-modal__feedback">
                  <div *ngIf="f.reportType?.errors?.required">{{ 'REPORT_TYPE_REQUIRED' | translate }}</div>
                </div>
              </div>

              <div class="col-12 col-lg-5 form-group">
                <label class="client-reporting-update-modal__label" for="isRollup">{{ 'ROLLUP_REPORT' | translate }}</label>
                <label class="client-reporting-update-modal__toggle-card" for="isRollup">
                  <input type="checkbox" id="isRollup" formControlName="isRollup" class="form-check-input">
                  <span class="client-reporting-update-modal__toggle-text">{{ 'IS_ROLLUP' | translate }}</span>
                </label>
              </div>
            </div>
          </div>

          <div class="client-reporting-update-modal__section" *ngIf="f.reportType.value === 'Simple' || selectedCampaignsByPlatform.Facebook.length >= 0 || selectedCampaignsByPlatform.Google.length >= 0">
            <div class="client-reporting-update-modal__section-title">{{ 'ADD_CAMPAIGNS' | translate }}</div>

            <div class="client-reporting-update-modal__platform-pickers" *ngIf="f.reportType.value">
              <ng-container *ngFor="let platform of ['Facebook', 'Google']">
                <app-client-reporting-update-select-campaigns-modal
                  *ngIf="f.reportType.value === 'Simple' || selectedCampaignsByPlatform[platform].length >= 0"
                  [ReportType]="f.reportType.value" [Platform]="platform" [CampaignsData]="CampaignsData"
                  (oSaveClicked)="addCampaignToConfig($event)" [CurrentlySelected]="selectedCampaignsByPlatform[platform]">
                </app-client-reporting-update-select-campaigns-modal>
              </ng-container>
            </div>

            <div class="client-reporting-update-modal__feedback" *ngIf="submitted && f.rmReportingConfigCampaigns?.errors">
              <div *ngIf="f.rmReportingConfigCampaigns?.errors?.required">{{ 'AT_LEAST_ONE_CAMPAIGN_REQUIRED' | translate }}</div>
            </div>

            <div formArrayName="rmReportingConfigCampaigns" class="client-reporting-update-modal__campaign-grid">
              <div class="client-reporting-update-modal__campaign-card" *ngFor="let crc of rmReportingConfigCampaigns.controls; let i = index" [formGroupName]="i">
                <div class="client-reporting-update-modal__campaign-card-header">
                  <div>
                    <div class="client-reporting-update-modal__campaign-platform">{{ crc.get('platform')?.value }}</div>
                    <div class="client-reporting-update-modal__campaign-name">{{ crc.get('campaignName')?.value }}</div>
                  </div>
                  <button type="button" class="client-reporting-update-modal__icon-button" (click)="removeReportingConfigCampaign(i)">
                    <i-feather name="trash-2"></i-feather>
                  </button>
                </div>

                <div class="client-reporting-update-modal__accounts-block" *ngIf="crc.get('adAccounts')?.value.length != 0">
                  <div class="client-reporting-update-modal__accounts-title">{{ 'AD_ACCOUNT_INFO' | translate }} ({{ crc.get('platform')?.value }})</div>
                  <table class="client-reporting-update-modal__accounts-table">
                    <tr>
                      <th>{{ 'AD_ACCOUNT_ID' | translate }}</th>
                      <th>{{ 'AD_CAMPAIGN_ID' | translate }}</th>
                      <th>{{ 'AD_LABEL' | translate }}</th>
                    </tr>
                    <tr *ngFor="let ad of crc.get('adAccounts')?.value;">
                      <td>{{ ad.platformAccountID }}</td>
                      <td>{{ ad.platformCampaignID }}</td>
                      <td>{{ ad.adLabel }}</td>
                    </tr>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </section>

        <aside class="client-reporting-update-modal__panel client-reporting-update-modal__panel--sidebar modal-panel">
          <div class="client-reporting-update-modal__panel-header modal-panel-header">
            <span class="client-reporting-update-modal__panel-eyebrow modal-panel-eyebrow">{{ 'CONTEXT' | translate }}</span>
            <h5 class="client-reporting-update-modal__panel-title modal-panel-title">{{ 'WEEKLY_REPORT_GUIDANCE' | translate }}</h5>
          </div>

          <div class="client-reporting-update-modal__sidebar-stack">
            <div class="client-reporting-update-modal__sidebar-block">
              <div class="client-reporting-update-modal__sidebar-title">{{ 'DELIVERY' | translate }}</div>
              <p class="client-reporting-update-modal__copy">{{ 'WEEKLY_REPORT_DELIVERY_COPY' | translate }}</p>
            </div>

            <div class="client-reporting-update-modal__sidebar-block">
              <div class="client-reporting-update-modal__sidebar-title">{{ 'MODE' | translate }}</div>
              <p class="client-reporting-update-modal__copy">{{ f.reportType.value === 'Advanced' ? ('ADVANCED_MODE_COPY' | translate) : ('SIMPLE_MODE_COPY' | translate) }}</p>
            </div>

            <div class="client-reporting-update-modal__sidebar-block">
              <div class="client-reporting-update-modal__sidebar-title">{{ 'CHECKLIST' | translate }}</div>
              <div class="client-reporting-update-modal__sidebar-list">
                <div class="client-reporting-update-modal__sidebar-list-item">{{ 'VERIFY_CLIENT_NAME_BEFORE_SAVING' | translate }}</div>
                <div class="client-reporting-update-modal__sidebar-list-item">{{ 'MAKE_SURE_TO_EMAIL_IS_VALID' | translate }}</div>
                <div class="client-reporting-update-modal__sidebar-list-item">{{ 'ADD_AT_LEAST_ONE_CAMPAIGN_FOR_REPORT' | translate }}</div>
                <div class="client-reporting-update-modal__sidebar-list-item">{{ 'REVIEW_ROLLUP_BEHAVIOR_IF_MULTIPLE_SOURCES' | translate }}</div>
              </div>
            </div>
          </div>
        </aside>
      </div>
    </div>

    <div class="modal-footer client-reporting-update-modal__footer" cdkDragHandle>
      <div class="client-reporting-update-modal__actions">
        <button type="button" class="red-outline-button client-reporting-update-modal__button modal-button" (click)="activeModal.close('Close click')">{{ 'CANCEL' | translate }}</button>
        <button type="submit" class="blue-button client-reporting-update-modal__button modal-button">{{ 'SAVE' | translate }}</button>
      </div>
    </div>
  </form>
</div>
